import { isAuthenticated, ProductReviewRating, useFormatCurrency } from '@ten24/slatwall-storefront-react-private/global'
import { ProductPrice } from '../ProductPrice/ProductPrice'
import { useTranslation } from 'react-i18next'

const ProductDetailHeading = ({ sku, product }) => {
  const { t } = useTranslation()
  const [formatCurrency] = useFormatCurrency({})
  //changes - Displaying just SKUcode and lineal meter price instead of brand and product type
  
  return (
    <>
      {!!sku?.skuCode?.trim()?.length && (
        <div className="row">
          <div className="col">
            <strong className="mb-2 text-muted text-uppercase small">{t('frontend.product.sku')} </strong>
            {sku.skuCode}

          </div>
        </div>
      )}

      {!!product?.linealMeter?.trim()?.length && (
        <div className="row">
          <div className="col">
            <strong className="mb-2 text-muted small">{t('frontend.product.linealmeter')} </strong>
            {formatCurrency(parseFloat(product.linealMeter))}
            &nbsp;<span>{t('frontend.includegst')}</span>
          </div>
        </div>
      )}
    </>
  )
}

const ProductDetails = ({ sku, product, config, ratingData }) => {//changes - getting config as a param
  const { t } = useTranslation()
  const { total, averageRating } = ratingData

  let showPrice = true
  switch (config?.price?.showCriteria) {
    case ("Authenticated Users"):
      showPrice = !!isAuthenticated()
      break;
    case('Never'):
      showPrice = false
      break;
    default:
      showPrice = true
  }

  return (
    <>
      <h3 className="fw-bold mb-3">{product.productName}</h3>

      <ProductDetailHeading sku={sku} product={product} />

      {total > 0 && config?.showReviews && (//changes - using config to validate display of the reviews
        <>
          <ProductReviewRating total={averageRating} />
          <a href="#productReviews" className="text-decoration-underline">
            {total + ' ' + t('frontend.product.review.totalReviewTitle')}
          </a>
        </>
      )}


      {/* changes - display the price according to the data received from the config */}
      {showPrice && (
        <div className="my-4">
          <strong className="display-6">{sku && <ProductPrice salePrice={sku.salePrice} listPrice={sku.listPrice} className="d-flex" ShowPriceForUserType={sku?.settings?.skuShowPriceForUserType} />}</strong>
        </div>
      )}

    </>
  )
}
export { ProductDetails, ProductDetailHeading }